import { BaseTool } from '../BaseTool';

/**
 * View control bar one-shot tools.
 *
 * These tools toggle view-scope state on the app store (view control bar
 * flags). The actual rendering/interaction effects live in the viewport
 * components, so activation is a simple state flip + back to Select.
 */

/** "Crop View" — toggles clipping of the model to the active view's crop region. */
export class CropViewTool extends BaseTool {
    id = 'VIEW_CROP';
    name = 'Crop View';
    cursor = 'default';

    onActivate(): void {
        this.context?.appStore.toggleViewFlag('cropView');
        this.deactivate();
        this.context?.appStore.setActiveTool('select');
    }

    onPointerDown(): void { }
    onPointerMove(): void { }
    onPointerUp(): void { }
}

/** "Reveal Hidden Elements" — hidden elements render in the reveal highlight. */
export class RevealHiddenElementsTool extends BaseTool {
    id = 'VIEW_REVEAL_HIDDEN';
    name = 'Reveal Hidden Elements';
    cursor = 'default';

    onActivate(): void {
        this.context?.appStore.toggleViewFlag('revealHidden');
        this.deactivate();
        this.context?.appStore.setActiveTool('select');
    }

    onPointerDown(): void { }
    onPointerMove(): void { }
    onPointerUp(): void { }
}

/** "Temporary Hide/Isolate" — cycles off -> isolate (selection) -> hide -> off. */
export class TemporaryHideIsolateTool extends BaseTool {
    id = 'VIEW_HIDE_ISOLATE';
    name = 'Temporary Hide/Isolate';
    cursor = 'default';

    onActivate(): void {
        this.context?.appStore.cycleHideIsolate();
        this.deactivate();
        this.context?.appStore.setActiveTool('select');
    }

    onPointerDown(): void { }
    onPointerMove(): void { }
    onPointerUp(): void { }
}
